import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class AtributosService extends ApiService {
    entityType = EntityType.ATRIBUTO;
    url = 'api/atributos/';
}
